<template>
<div>
  <div class="row">
    <div class="col-md-12 intro">
      <h4>Botão de Doação</h4>
      <span>Copie o código abaixo e insira no site de sua Organização Social ou blog. 
        Ao clicar em nosso botão "Contribuir com Click2giv" os visitantes de seu site e blog 
        serão direcionados para a página de meios de pagamentos vinculados à sua Organização 
        ou campanha publicada na click2giv.</span>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 textbox">
      <textarea id="textbutton" readonly class="form-control" v-model="content"></textarea>
      <button class="btn" v-on:click.stop.prevent="copyToClipboard()">Copiar</button>
    </div>
  </div>
  
</div>
</template>

<script>
import auth from '../../services/auth'
import Functions from '../../utils/functions'
import { API } from '../../services/api'
import { VueEditor } from 'vue2-editor'

export default {
  name: 'ProjectButton',
  props: ['project'],
  components: {
    VueEditor
  },
  data(){
    return {
      msg: '',
      content: '',
      page: 'button'
    }
  },
  mounted(){
    this.content = '<!-- INICIO DO BOTAO CLICK2GIV -->' +
      '<form action="https://click2giv.com/project/donate/' + this.project.slug + '" method="get">' +
      '<input type="image" src="https://click2giv.com/images/botao_contribua.png" name="submit" alt="Contribua com os projetos da click2giv e mude vidas." />' +
      '</form><!-- FINAL DO BOTAO CLICK2GIV -->';
  },
  methods: {
    copyToClipboard(){
      var copyText = document.getElementById("textbutton");
      copyText.select();
      document.execCommand("copy");
    }
  }
}
</script>

<style lang="scss" scoped>
.textbox{
  position: relative;
  height: 170px;
  margin-top: 20px;
}
textarea{
  height: 170px;
  resize: none;
}
h4{
  color: #00AE39;
  margin-bottom: 1px;
}
span{
  font-size: 15px;
}
.form-config{
    margin-top: 20px;
    .row{
      padding: 20px;
      border-bottom: thin solid #eee;
      &:last-child{
        border-bottom: none;
      }
    }
    .btn{
      font-size: 22px;
      color: #fff;
      background-color: #00AE39;
      &.clear-project{
        background-color: red;
      }
      &:hover{
        background-color: #aaa;
        color: #333;
      }
    }
}
.btn{
  position: absolute;
  right: 20px;
  bottom: 10px;
  font-size: 14px !important;
  background-color: #00AE39;
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/manage-project/Button.vue